import { render, staticRenderFns } from "./reisetermin-state-badge.vue?vue&type=template&id=93be1be8"
import script from "./reisetermin-state-badge.vue?vue&type=script&lang=js"
export * from "./reisetermin-state-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports